// extracted by mini-css-extract-plugin
export default {"peoplePicker":"PeoplePicker_peoplePicker__fkbqm","removedWrapper":"PeoplePicker_removedWrapper__7Nl24"};